import { render, staticRenderFns } from "./DHUnitDetail.vue?vue&type=template&id=1e5f4991&"
import script from "./DHUnitDetail.vue?vue&type=script&lang=js&"
export * from "./DHUnitDetail.vue?vue&type=script&lang=js&"
import style0 from "./DHUnitDetail.vue?vue&type=style&index=0&id=1e5f4991&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports